import { createClient, type SupabaseClient } from '@supabase/supabase-js'

import type { Database } from '@/data'
import type { SupabaseConfig } from '@/lib/supabaseConfig'

export const createSupabase = ({ url, anonKey }: SupabaseConfig): SupabaseClient<Database> =>
  createClient<Database>(url, anonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storageKey: 'supabase.auth.token',
    },
  })
